import styled from 'styled-components';
import { StyledAdminUsersRowsWidth } from '../../AdminEditUsers/styles';
import { StyledAdminListHeaders } from '../../AdminListHeaderCell/styles/StyledAdminListHeaders';

export const StyledAdminUsersListHeader = styled.div`
  ${StyledAdminListHeaders}

  .admin-list-header-cell-container {
    ${StyledAdminUsersRowsWidth}
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
